import apolloClient from '../../utils/apollo-client';
import { getFile as query } from '../graphql/file';

export default async function getFile(uuid) {
  const response = await apolloClient().then((client) =>
    client.query({
      query,
      variables: { uuid }
    })
  );

  return response.data.getFile;
}
